import {ChangeDetectionStrategy, Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {DynamicModule} from 'ng-dynamic-component';
import {NgComponentOutlet} from '@angular/common';
import {StoryblokBaseComponent} from '../storyblok-base.component';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';

@Component({
  selector: 'app-storyblok-group',
  templateUrl: './storyblok-group.component.html',
  styleUrls: ['./storyblok-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicModule, NgComponentOutlet]
})
export class StoryblokGroupComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokComponentService = inject(StoryblokComponentService);
  private storyblokStylingService = inject(StoryblokStylingService);


  components: any;
  selected: string;

  constructor() {
    super();
    this.components = this.storyblokComponentService.getComponents();
  }

  readonly body = input.required<any[]>();
  readonly fullWidth = input<boolean>();
  readonly _editable = input<any>();
  readonly general_styling = input<any>();

  @HostBinding('class') class: any;

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12});
    this.selected = this.body()[0].title;
  }

}
